/**
 * Small info alert with a warning icon, shown under a line's quantity or price to say a value was
 * changed for the customer (every caller passes its translation of "Values have been updated" or
 * "Pricing UOM updated").
 *
 * Used by the cart's `../ShoppingCartTableQuantityUomCell.tsx` and
 * `../ShoppingCartTablePriceUOMCellPriceData.tsx`, and outside the cart by
 * `components/QuoteDetails/Helpers/RowPriceUomData.tsx`,
 * `components/QuoteDetails/Helpers/RowQuantityAndQuantityUomData.tsx` and the checkout
 * order-details cells (`components/Shared/CheckoutOrderDetails/CheckoutOrderDetailsTable/Helper/`
 * `CheckoutOrderDetailsTableQuantityCell.tsx` and `CheckoutOrderDetailsTablePricePerUOMCell.tsx`).
 * The caller decides when it shows and hides.
 */
import { Flex } from "@ryerson/frontend.layout";
import React from "react";
import { StyledAlert } from "./StyledComponents";
import { Typography } from "@ryerson/frontend.typography";

/**
 * Renders `quantityOrPriceContent` (already translated) in the alert. On desktop the alert is at
 * most 173px wide; on mobile it takes the full width.
 */
const ShoppingCartAlert: React.FC<{
	isMobile: boolean;
	quantityOrPriceContent: string;
}> = ({ isMobile, quantityOrPriceContent }) => {
	return (
		<Flex
			css={{
				...(!isMobile && {
					maxWidth: 173,
				}),
				width: "100%",
			}}
		>
			<StyledAlert severity={"info"} icon={"warning"} size="sm">
				<Typography
					css={{
						width: "100%",
					}}
				>
					{quantityOrPriceContent}
				</Typography>
			</StyledAlert>
		</Flex>
	);
};

export default ShoppingCartAlert;
